import { Grid, Row } from 'react-bootstrap'
import React, { Component } from 'react'

import { GridPanel } from '../components/Em/GridPanel'
import Loader from 'react-loader-advanced'
import PropTypes from 'prop-types'
import { axios } from 'config/axios'
import { connect } from 'react-redux'
import { getEmDataColletionBySessionId } from '../api/ispyb.js'
import { setBreadCrumbs } from '../actions/breadcrumbs.js'

class EmSessionsContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fetching: true,
      fetched: false,
      dataCollections: [],
      error: null,
    }
  }

  /**
   * This method will retrieve the dataCollections for a given session
   */
  componentDidMount() {
    const _this = this

    axios({
      method: 'GET',
      url: getEmDataColletionBySessionId(this.props.user, this.props.proposal, this.props.sessionId),
    })
      .then(function (response) {
        for (let i = 0; i < response.data.length; i++) {
          if (!response.data[i].stats) {
            response.data[i].stats = []
          }
        }
        _this.setState({
          dataCollections: response.data,
          fetching: false,
          fetched: true,
        })
      })
      .catch(function (error) {
        _this.setState({
          error: error,
          fetching: false,
          fetched: false,
        })
      })
  }

  render() {
    if (!this.props.user || !this.props.user.token) {
      return null
    }
    return (
      <div style={{ marginBottom: '100px' }}>
        <Loader show={this.state.fetching}>
          <Grid fluid>
            {this.state.dataCollections.map((value, index) => (
              <div key={index}>
                <Row>
                  <GridPanel
                    startTimeList={value.startTimeList}
                    sampleName={value.BLSample_name}
                    voltageList={value.voltageList}
                    gridSquaresCount={value.totalNumberOfDataCollections}
                    framesCount={value.imagesCount}
                    samplingRate={value.DataCollection_xBeamPix}
                    voltage={value.DataCollection_voltage}
                    magnificationList={value.magnificationList}
                    dataCollectionIdList={value.dataCollectionIdList}
                    stats={value.stats}
                    imageDirectoryList={value.imageDirectoryList}
                    user={this.props.user}
                    proposal={this.props.proposal}
                    sessionId={this.props.sessionId}
                  />
                </Row>
              </div>
            ))}
          </Grid>
        </Loader>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadCrumbs: breadCrumbs => dispatch(setBreadCrumbs(breadCrumbs)),
  }
}

EmSessionsContainer.propTypes = {
  sessionId: PropTypes.string,
  proposal: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(EmSessionsContainer)
